import {ProposalInformation} from './proposal-information';
import {Partner} from './partner';
import {RiskLocation} from './risk-location';
import {PreviousDamage} from './previous-damage';
import {ProposalUser} from './proposalUser';
import {LineOfBusiness} from './line-of-business';
import {LeadingOfferInfo} from './leading-offer-info';


export class Proposal {
  proposalInformation: ProposalInformation = new ProposalInformation();
  partner: Partner = new Partner();
  riskLocations: RiskLocation[] = [];
  previousDamages: PreviousDamage[] = [];
  lineOfBusiness: LineOfBusiness = null;
  leadingOfferInfo: LeadingOfferInfo = null;
  creator: ProposalUser = new ProposalUser();
  lastTimeEdited: Date = null;

  constructor(proposal?: any) {
    if (proposal == null) {
      return;
    }
    if (proposal.proposalInformation != null) {
      this.proposalInformation = new ProposalInformation(proposal.proposalInformation);
    }
    if (proposal.partner != null) {
      this.partner = new Partner(proposal.partner);
    }
    if (proposal.riskLocations != null) {
      proposal.riskLocations.forEach(riskLocation => this.riskLocations.push(new RiskLocation(riskLocation)));
    }
    if (proposal.previousDamages != null) {
      proposal.previousDamages.forEach(previousDamage => this.previousDamages.push(new PreviousDamage(previousDamage)));
    }
    if (proposal.lineOfBusiness != null) {
      this.lineOfBusiness = new LineOfBusiness(proposal.lineOfBusiness);
    }
    if (proposal.leadingOfferInfo != null) {
      this.leadingOfferInfo = new LeadingOfferInfo(proposal.leadingOfferInfo);
    }
    if (proposal.creator != null) {
      this.creator = new ProposalUser(proposal.creator);
    }
  }

  get proposalNumber() {
    return this.proposalInformation?.id?.slice(0, 8);
  }
}
